export const initialState = {
  isFetching: false,
  isVisible: false,
  items: {
    subscription: null,
    products: {
      ids: [],
      items: {},
    },
    beautyBag: {
      items: [],
      stepsLeft: 0,
    },
  },
  discount: 0,
  totalPrice: 0,
  appliedPriceRules: {},
}

export const setVisibility = (state, payload) => ({ ...state, isVisible: payload })

export const update = (state, payload) => ({ ...state, ...payload })

export const updateProductAmount = (state, { id, amount }) => {
  const newState = { ...state }
  const { items: { products: { items } } } = newState

  if (amount > 0) {
    items[id] = { ...items[id], amount }
  }

  return newState
}

export const updateProduct = (state, { id, product }) => {
  const newState = { ...state }
  const { items: { products: { items, ids } } } = newState

  if (product !== undefined) {
    items[id] = product
  }
  else {
    const index = ids.indexOf(id)

    if (index >= 0) {
      // remove product
      ids.splice(index, 1)
      delete items[id]
    }
  }

  return newState
}

export const setFetching = (state, payload) => ({ ...state, isFetching: payload })

export const setTotalPrice = (state, payload) => ({ ...state, totalPrice: payload })

export const clear = () => initialState
